import { CAST_AI } from '@cast/constants';
import { Button, Icons, HexIcon, Typography, Stack } from '@cast/design-system';

import { useAssignCredentialsDialogV2 } from 'hooks/dialogs';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const ActionRequired = () => {
  const { cluster } = useCluster();
  const { openAssignCredentialsDialog } = useAssignCredentialsDialogV2();

  return (
    <Stack
      alignItems="center"
      alignSelf="center"
      gap={8}
      mt={16}
      data-testid="action-required-message"
    >
      <HexIcon
        variant="notification"
        icon={<Icons.Polygon weight="fill" />}
        size={72}
      />

      <Stack gap={4} mb={16}>
        <Typography variant="h5" textAlign="center">
          Action required
        </Typography>

        <Typography variant="P14R" color="textSecondary">
          Please install new metrics collection component to see network cost
          use metrics.
        </Typography>
      </Stack>

      <Button
        testId="enable-cast-ai-button"
        size="md"
        onClick={() =>
          openAssignCredentialsDialog({
            cluster,
            productName: 'networkCostMetrics',
          })
        }
      >
        Enable {CAST_AI}
      </Button>
    </Stack>
  );
};
